import React from 'react';

import MediaUpload from './media-upload';

const ThumbUpload = ({ placeHolder, ...props }) => {
  return <MediaUpload {...props} iconLabel={placeHolder} />;
};

export default ThumbUpload;
